// libs
import React, { useCallback } from 'react';
import c from 'classnames';

import { CheckMark } from '@lyearn/icons';
import { BaseMenuItem, BaseMenuList, Typography } from '@lyearn/ui';

import { blockType } from '../../types/menus';
import {
  iconStyle,
  listItemTypography,
  menuItemSelectedStyle,
  tickedMenuItemMenuWidth,
} from './style';
import { TurnIntoMenuItemProps } from './types';

const TurnIntoMenuItem = (props: TurnIntoMenuItemProps) => {
  const { blocks, onClick, selectedMenuItemIndex, autoFocus } = props;

  const onItemClick = useCallback(
    (event: any) => {
      const index = event.currentTarget.getAttribute('data-index');
      const block = blocks[index];
      onClick?.(block);
    },
    [blocks, onClick],
  );

  return (
    <BaseMenuList
      autoFocus={autoFocus}
      className={c(
        'rounded-4 bg-bg-primary px-8 shadow-01 outline-none xs:px-0',
        selectedMenuItemIndex !== undefined ? tickedMenuItemMenuWidth : '',
      )}>
      {blocks.map((block: blockType, index) => (
        <BaseMenuItem
          key={index}
          className={c(
            'my-2 flex h-40 items-center rounded-8 p-10 hover:bg-s-info-light',
            menuItemSelectedStyle,
          )}
          data-id={block.title}
          data-index={index}
          selected={index === selectedMenuItemIndex}
          onClick={onItemClick}>
          <block.icon className={c('fill-current text-icon-secondary', iconStyle)} />
          <Typography
            className={c('text-text-secondary', listItemTypography)}
            variant="body-short-02">
            {block.title}
          </Typography>
          {selectedMenuItemIndex === index && (
            <CheckMark className={c('absolute fill-current text-icon-active end-20', iconStyle)} />
          )}
        </BaseMenuItem>
      ))}
    </BaseMenuList>
  );
};

export default React.memo(TurnIntoMenuItem);
